import { MainPage } from '@/pages/MainPage.tsx';
import { Route, Routes, HashRouter } from 'react-router-dom';
import { WishlistPage } from "@/pages/WishlistPage.tsx";
import { AuthLayout, WishlistLayout } from "@/pages/layout";
import { AuthProvider } from "@/providers";
import {WishlistProvider} from "@/providers/WishlistProvider.tsx";
import {EditWishPage} from "@/pages/EditWishPage.tsx";
import {GiftedWishPage} from "@/pages/GiftedWishPage.tsx";
import {EditWishlistPage} from "@/pages/EditWishlistPage.tsx";
import {ProfileLayout} from "@/pages/layout/ProfileLayout.tsx";
import {AuthProfileLayout} from "@/pages/layout/AuthProfileLayout.tsx";
import {AuthProfileProvider} from "@/providers/AuthProfileProvider.tsx";
import {CreateWishlistPage} from "@/pages/CreateWishlistPage.tsx";
import {NavigationProvider} from "@/providers/NavigationProvider.tsx";
import {AllWishes} from "@/pages/AllWishes.tsx";
import {ProfilePage} from "@/pages/ProfilePage.tsx";
import {ResolveStartParam} from "@/pages/ResolveStartParam.tsx";
import {UserSettingsPage} from "@/pages/UserSettingsPage.tsx";
import {SecretSantaProvider} from "@/providers/SecretSantaProvider.tsx";
import {SecretSantaListPage} from "@/pages/SecretSantaListPage.tsx";
import {CreateSecretSantaPage} from "@/pages/CreateSecretSantaPage.tsx";
import {SecretSantaGamePage} from "@/pages/SecretSantaGamePage.tsx";
import {JoinSecretSantaPage} from "@/pages/JoinSecretSantaPage.tsx";
import {EditSecretSantaGamePage} from "@/pages/EditSecretSantaGamePage.tsx";
import {AllIdeasPage} from "@/pages/AllIdeasPage.tsx";
import {GiftedWishesPage} from "@/pages/GiftedWishesPage.tsx";
import {GiftedWishLayout} from "@/pages/layout/GiftedWishLayout.tsx";

export const Router = () => {
  return (
    <AuthProvider>
        <HashRouter>
          <Routes>
            <Route path="/" element={<NavigationProvider><AuthLayout/></NavigationProvider>}>
              <Route element={<AuthProfileProvider>
                <AuthProfileLayout/>
              </AuthProfileProvider>}>
              <Route path="/main">
                <Route index Component={MainPage} />
                <Route path="/main/settings" Component={UserSettingsPage} />
                <Route path="/main/wishlists/new" Component={CreateWishlistPage} />
                <Route path="/main/wishlists/:wishlistId" element={<WishlistProvider>
                  <WishlistLayout/>
                </WishlistProvider>}>
                  <Route index Component={WishlistPage} />
                  <Route path="/main/wishlists/:wishlistId/edit" Component={EditWishlistPage} />
                  <Route path="/main/wishlists/:wishlistId/wishes/:wishId" Component={WishlistPage} />
                  <Route path="/main/wishlists/:wishlistId/wishes/new" Component={EditWishPage} />
                  <Route path="/main/wishlists/:wishlistId/wishes/:wishId/edit" Component={EditWishPage} />
                  <Route path="/main/wishlists/:wishlistId/wishes/:wishId/gifted" Component={GiftedWishPage} />
                </Route>

                <Route path="/main/wishes/all" Component={AllWishes} />
                <Route path="/main/wishes/all/:wishId" Component={AllWishes} />
                <Route path="/main/wishes/all/:wishId/edit" Component={EditWishPage} />
                <Route path="/main/wishes/all/:wishId/gifted" element={<GiftedWishLayout/>}>
                  <Route index Component={GiftedWishPage} />
                </Route>
                <Route path="/main/wishes/new" Component={EditWishPage} />
                <Route path="/main/wishes/gifted" Component={GiftedWishesPage} />
                <Route path="/main/wishes/gifted/:wishId" element={<GiftedWishLayout/>}>
                  <Route index Component={GiftedWishPage} />
                  <Route path="edit" Component={EditWishPage} />
                </Route>

                <Route path="/main/ideas/all" Component={AllIdeasPage} />

                <Route path="/main/secret-santa" Component={SecretSantaListPage} />
                <Route path="/main/secret-santa/new" Component={CreateSecretSantaPage} />
                <Route path="/main/secret-santa/:gameId" element={<SecretSantaProvider><SecretSantaGamePage /></SecretSantaProvider>} />
                <Route path="/main/secret-santa/:gameId/edit" element={<SecretSantaProvider><EditSecretSantaGamePage /></SecretSantaProvider>} />
                <Route path="/main/secret-santa/:gameId/join" element={<SecretSantaProvider><JoinSecretSantaPage /></SecretSantaProvider>} />
              </Route>
              <Route path="/profiles/:userId" Component={ProfileLayout}>
                <Route index Component={ProfilePage} />
                <Route path="/profiles/:userId/wishes/gifted" Component={GiftedWishesPage} />
              </Route>
              <Route path="/wishlists/:wishlistId" element={<WishlistProvider>
                <WishlistLayout/>
              </WishlistProvider>}>
                <Route index Component={WishlistPage} />
                <Route path="/wishlists/:wishlistId/edit" Component={EditWishlistPage} />
                <Route path="/wishlists/:wishlistId/wishes/:wishId" Component={WishlistPage} />
                <Route path="/wishlists/:wishlistId/wishes/new" Component={EditWishPage} />
                <Route path="/wishlists/:wishlistId/wishes/:wishId/edit" Component={EditWishPage} />
                <Route path="/wishlists/:wishlistId/wishes/:wishId/gifted" Component={GiftedWishPage} />
              </Route>
              <Route index Component={ResolveStartParam} />
              </Route>
            </Route>
            <Route path="*" Component={ResolveStartParam}/>
          </Routes>
        </HashRouter>
    </AuthProvider>
  );
}
